import { createSelector } from 'reselect';

const tagIds = (state) => state.tags.ids;

export const getTagsById = (state) => state.entities.tags;

export const getIsLoading = (state) => state.tags.isLoading;

export const getActiveTagId = (state) => state.tags.activeDashboardId;

export const getActiveTag = createSelector(
  [getTagsById, getActiveTagId],
  (tags, id) => tags[id],
);

export const getAllTags = createSelector(
  [getTagsById, tagIds],
  (tags, ids) => ids.map((id) => tags[id]),
);
